import React from 'react'
import Input from '@/components/Input'
import type { SDUIComponentProps } from '@/types/sduiTypes'

/**
 * SDUI TextInput adapter — wraps the existing Input component
 * to conform to the SDUI component contract.
 */
const SDUITextInput: React.FC<SDUIComponentProps> = ({
    id,
    label,
    value,
    errors,
    disabled,
    placeholder,
    type,
    onChange,
    onBlur,
}) => {
    const hasErrors = errors && errors.length > 0

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(e.target.value)
    }

    const handleBlur = () => {
        onBlur?.()
    }

    return (
        <div className="w-full">
            {label && (
                <label
                    htmlFor={id}
                    className="block font-medium text-gray-700 dark:text-gray-200 mb-1 text-sm"
                >
                    {label}
                </label>
            )}
            <Input
                id={id}
                type={(type as string) || 'text'}
                value={(value as string) ?? ''}
                disabled={disabled}
                invalid={hasErrors}
                placeholder={(placeholder as string) || ''}
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
            />
            {hasErrors && (
                <div className="mt-1">
                    {errors.map((err, idx) => (
                        <p
                            key={`${id}-error-${idx}`}
                            className="text-red-500 text-xs"
                        >
                            {err}
                        </p>
                    ))}
                </div>
            )}
        </div>
    )
}

SDUITextInput.displayName = 'SDUITextInput'

export default SDUITextInput
